module.exports = require("./ms.d.ts");